import { render, staticRenderFns } from "./ComplaintDetailEvent.vue?vue&type=template&id=a4dc2150&scoped=true"
import script from "./ComplaintDetailEvent.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetailEvent.vue?vue&type=style&index=0&id=a4dc2150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dc2150",
  null
  
)

export default component.exports